<template>
  <div class="card">
    <div class="card-header">
      <div class="text-center">
        <div
          class="font-size-18 mb-3 d-flex align-items-center justify-content-center"
        >
          <img
            src="/resources/images/logos/EDparent_small.png"
            alt="EdParent"
            class="app-logo me-3"
          />
          <span>EdParent</span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <a-divider class="m-0">{{ $t("profil.nomUser") }}:</a-divider>
      <p class="text-gray-5 mb-2">
        {{ userName }}
      </p>
      <a-divider>{{ $t("profil.mdp") }}:</a-divider>
      <a-button-group class="d-flex justify-content-center">
        <a-button @click="showModal"> {{ $t("action.modifier") }} </a-button>
        <a-popconfirm
          :title="$t('sms.alertNumberSMS')"
          :ok-text="$t('action.confirmer')"
          :cancel-text="$t('action.annuler')"
          @confirm="() => sendSmsLoginToParent()"
        >
          <a-button
            type="primary"
            :loading="loadingSms"
            :disabled="loadingSms || disableBtns"
            :class="{
              disabledPack: !btnAccessGetter.includes('sendSmsLogins'),
            }"
          >
            {{ $t("menu.envoyerSms") }}
          </a-button>
        </a-popconfirm>
      </a-button-group>
    </div>
    <a-modal
      v-model="visible"
      :title="$t('profil.changerPrametreParents')"
      width="60%"
      :ok-button-props="{
        props: { disabled: hasErrors(form.getFieldsError()) },
      }"
      @cancel="handleCancel"
    >
      <a-tabs default-active-key="father" @change="handleTabChange">
        <a-tab-pane key="father" :tab="$t('profil.father')" />
        <a-tab-pane key="mother" :tab="$t('profil.mother')" />
        <a-tab-pane key="guardian" :tab="$t('profil.guardian')" />
      </a-tabs>
      <div class="row" v-if="info[parentType] && info[parentType].login">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">
                {{ $t("parentalControl.changeUserName") }}
              </p>
              <a-form
                layout="inline"
                :form="form"
                @submit="handleUserNameChange"
                class="login-form"
                style="width: 100%"
              >
                <a-form-item
                  :validate-status="userNameError() ? 'error' : ''"
                  :help="userNameError() || ''"
                  style="width: 100%"
                >
                  <a-input
                    style="width: 100%"
                    v-decorator="[
                      'userName',
                      {
                        initialValue: userName,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.username'),
                          },
                          {
                            validator: validateNoWhitespace,
                            message: $t('requis.noWhitespace'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.nomUser')"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input>
                </a-form-item>
                <a-button
                  type="primary"
                  class="mt-4"
                  @click="handleUserNameChange"
                  :loading="userNameLoading"
                  :disabled="userNameLoading || disableBtns"
                  >{{ $t("action.enregistrer") }}</a-button
                >
              </a-form>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div
            :class="
              status == 'inactive'
                ? 'card border-danger mb-3'
                : 'card border-success mb-3'
            "
          >
            <div class="card-header text-dark">
              {{ $t("parentalControl.disableAccount") }}
            </div>
            <div class="card-body">
              <p class="card-text">
                <a-tag :color="status == 'inactive' ? 'red' : 'green'">
                  {{
                    status == "active"
                      ? $t("parentalControl.accountActive")
                      : $t("parentalControl.accountInactive")
                  }}
                </a-tag>
              </p>

              <a-button
                type="primary"
                @click="changeStatus"
                :loading="statusBtnLoading"
                :disabled="statusBtnLoading"
              >
                {{
                  status == "active"
                    ? $t("parentalControl.disableAccount")
                    : $t("parentalControl.enableAccount")
                }}
              </a-button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div
            :class="
              mfaEnabled
                ? 'card border-warning mb-3'
                : 'card border-secondary mb-3'
            "
          >
            <div class="card-header text-dark">
              {{ $t("mfa.twoFactorAuth") }}
            </div>
            <div class="card-body">
              <p class="card-text">
                <a-tag :color="mfaEnabled ? 'orange' : 'gold'">
                  {{
                    mfaEnabled
                      ? $t("mfa.adminStatusOn")
                      : $t("mfa.adminStatusOff")
                  }}
                </a-tag>
              </p>
              <p v-if="mfaEnabled" class="text-muted mb-3">
                {{ $t("mfa.method") }}:
                {{
                  mfaMethod === "sms"
                    ? $t("mfa.sms")
                    : $t("mfa.authenticatorApp")
                }}
              </p>
              <a-popconfirm
                v-if="mfaEnabled"
                :title="$t('mfa.adminDisableConfirm')"
                :ok-text="$t('mfa.disable')"
                :cancel-text="$t('action.annuler')"
                @confirm="disableMfa"
              >
                <a-button
                  type="danger"
                  :loading="mfaDisabling"
                  :disabled="mfaDisabling || disableBtns"
                >
                  {{ $t("mfa.disable") }}
                </a-button>
              </a-popconfirm>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">
                {{ $t("profil.resetPwd") }}
              </p>
              <a-form
                layout="inline"
                :form="passwordForm"
                @submit="handlePasswordChange"
                class="login-form"
                style="width: 100%"
              >
                <a-form-item
                  :validate-status="passwordError() ? 'error' : ''"
                  :help="passwordError() || ''"
                  style="width: 100%"
                >
                  <a-input-password
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            validator: validateStrongPassword,
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.NewPwd')"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                </a-form-item>
                <a-form-item
                  :validate-status="passworConfirmdError() ? 'error' : ''"
                  :help="passworConfirmdError() || ''"
                  style="width: 100%"
                >
                  <a-input-password
                    v-decorator="[
                      'confirmPassword',
                      {
                        rules: [
                          {
                            validator: validatePass2,
                            message: $t('requis.confirmation'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.ConfirmNewPwd')"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                </a-form-item>
                <a-button
                  type="primary"
                  class="mt-2"
                  @click="handlePasswordChange"
                  :loading="passwordLoading"
                  :disabled="passwordLoading || disableBtns"
                  >{{ $t("action.enregistrer") }}</a-button
                >
              </a-form>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">
                {{ $t("parentalControl.parentQrCode") }}
              </p>
              <vue-qr
                :text="qrData"
                :logoSrc="getBuilding.logo"
                :callback="getQrImage"
                qid="student"
              ></vue-qr>
              <a-button
                type="primary"
                class="mt-2"
                @click="ImprimerQr"
                :loading="qrCodeLoading"
                :disabled="qrCodeLoading || disableBtns"
                >{{ $t("action.imprimer") }}</a-button
              >
            </div>
          </div>
        </div>
      </div>
      <div v-else class="preview-placeholder">
        <div
          class="preview-empty"
          v-if="
            info[parentType] &&
            Object.keys(info[parentType]).length > 0 &&
            info[parentType].lastName &&
            !info[parentType].login
          "
        >
          <a-icon type="user" class="preview-icon" style="font-size: 48px" />
          <p class="preview-text">
            {{
              $t("profil.noParentCredentials", {
                parentType: $t("profil." + parentType),
              })
            }}
          </p>
          <a-button
            type="success"
            @click="addParentCredentials"
            :loading="addParentCredentialsLoading"
            :disabled="addParentCredentialsLoading || disableBtns"
          >
            <a-icon type="user" />
            {{ $t("profil.ajouterCompteParent") }}
          </a-button>
        </div>
        <div class="preview-empty" v-else>
          <a-icon
            type="warning"
            class="preview-icon"
            style="font-size: 48px; color: #d9d9d9"
          />
          <p class="preview-text">
            {{
              $t("profil.noParentInfo", {
                parentType: $t("profil." + parentType),
              })
            }}
          </p>
          <a-button type="primary" @click="handleCancel">
            <a-icon type="arrow-left" />
            {{ $t("all.okay") }}
          </a-button>
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          {{ $t("action.retour") }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState, mapActions, mapGetters } from "vuex";
import VueQr from "vue-qr";
const { generateLoginPdf } = require("@/utilities/pdfLogin");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
import "./controlParental.css";
export default {
  name: "controlParentale",
  computed: {
    ...mapState(["settings"]),
    ...mapGetters("settings", ["btnAccessGetter"]),
    getBuilding() {
      return (
        this.settings.image.filter(
          (img) => img.db == this.settings.activeBuilding
        )[0] || {}
      );
    },
    userName() {
      return this.info[this.parentType]?.login?.userName || "";
    },
    status() {
      return this.info[this.parentType]?.status || "inactive";
    },
    mfaEnabled() {
      return !!this.info[this.parentType]?.login?.mfa?.enabled;
    },
    mfaMethod() {
      return this.info[this.parentType]?.login?.mfa?.method || "app";
    },
    phones() {
      return this.info[this.parentType]?.phone || "";
    },
    qrData() {
      if (
        Object.keys(this.loginHashes).length > 0 &&
        this.loginHashes[this.parentType]
      ) {
        return window.btoa(
          this.loginHashes[this.parentType] + "#" + this.settings.base_url
        );
      }
      return "";
    },
  },
  components: {
    VueQr,
  },
  props: {
    idParent: {
      required: false,
    },
    loginHashes: {
      required: false,
    },
    info: {
      required: false,
    },
  },
  methods: {
    setloadingKeyAndDisableBtns(loadingkey, value) {
      // ensure boolean
      value = Boolean(value);
      this[loadingkey] = value;
      this.disableBtns = value;
    },
    handleTabChange(key) {
      this.parentType = key;
      this.form.resetFields();
      this.passwordForm.resetFields();
    },
    ImprimerQr() {
      this.setloadingKeyAndDisableBtns("qrCodeLoading", true);
      let parentCred = {
        userName: this.userName,
      };
      this.generatePdf(parentCred);
      this.setloadingKeyAndDisableBtns("qrCodeLoading", false);
    },
    handleCancel() {
      this.visible = false;
      this.form.resetFields();
      this.passwordForm.resetFields();
    },
    validateNoWhitespace(rule, value, callback) {
      if (/\s/.test(value)) {
        callback(new Error("Username cannot contain whitespace"));
      } else {
        callback();
      }
    },
    validateStrongPassword(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("requis.mdp")));
      } else if (value == this.userName) {
        callback(new Error(this.$t("profil.passwordMustNotMatchUsername")));
      } else if (value.length < 8) {
        callback(new Error(this.$t("profil.passwordMinLength")));
      } else if (!/[A-Z]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeUppercase")));
      } else if (!/[a-z]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeLowercase")));
      } else if (!/[0-9]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeDigit")));
      } else {
        callback();
      }
    },

    validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.passwordForm.getFieldValue("password")) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    },
    showModal() {
      this.visible = true;
    },
    getQrImage(dataUrl) {
      this.qrDataImage = dataUrl;
    },
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return getFieldError("userName");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.passwordForm;
      return getFieldError("password");
    },
    passworConfirmdError() {
      const { getFieldError, isFieldTouched } = this.passwordForm;
      return getFieldError("confirmPassword");
    },
    addParentCredentials() {
      this.setloadingKeyAndDisableBtns("addParentCredentialsLoading", true);
      apiClient
        .put(
          "/parents/" + this.idParent + "/createCrendential/" + this.parentType
        )
        .then(({ data }) => {
          this.$message.success(data.message);
          this.$emit("parentUpdated", this.parentType, {
            login: { userName: data.parentCredential.userName },
          });
          this.$emit("requestLoginHash", this.idParent);
          this.generatePdf(data.parentCredential, true);
          this.handleCancel();
        })
        .catch((e) => {
          this.$message.error(e.response.data.error.message);
        })
        .finally(() => {
          this.setloadingKeyAndDisableBtns(
            "addParentCredentialsLoading",
            false
          );
        });
    },
    disableMfa() {
      this.setloadingKeyAndDisableBtns("mfaDisabling", true);
      apiClient
        .patch("/parents/mfa/disable/" + this.idParent + "/" + this.parentType)
        .then(() => {
          this.$message.success(this.$t("mfa.adminDisableSuccess"));
          this.$emit("parentUpdated", this.parentType, {
            login: {
              ...this.info[this.parentType].login,
              mfa: { enabled: false, method: null },
            },
          });
        })
        .catch(() => {
          this.$message.error(this.$t("mfa.adminDisableError"));
        })
        .finally(() => {
          this.setloadingKeyAndDisableBtns("mfaDisabling", false);
        });
    },
    changeStatus() {
      this.setloadingKeyAndDisableBtns("statusBtnLoading", true);
      let newStatus = this.status == "active" ? "inactive" : "active";
      apiClient
        .patch("/parents/" + this.idParent, {
          data: {
            [this.parentType]: {
              status: newStatus,
            },
          },
        })
        .then(async ({ data }) => {
          this.$message.success("Changement effectué avec succeées");
          this.$emit("parentUpdated", this.parentType, {
            status: newStatus,
          });
        })
        .catch((e) => {
          this.$message.error(this.$t("changementNonEffectue"));
        })
        .finally(() => {
          this.setloadingKeyAndDisableBtns("statusBtnLoading", false);
        });
    },
    handleUserNameChange(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) console.log(err);
        else {
          this.setloadingKeyAndDisableBtns("userNameLoading", true);
          apiClient
            .patch(
              "/parents/username/" + this.idParent + "/" + this.parentType,
              values
            )
            .then(async () => {
              this.$message.success(this.$t("success.parentMSA"));
              this.generatePdf(values);

              this.$emit("parentUpdated", this.parentType, {
                login: {
                  userName: values.userName,
                },
              });
            })
            .catch((e) => {
              this.$message.error(e.response.data.error.message);
            })
            .finally(() => {
              this.setloadingKeyAndDisableBtns("userNameLoading", false);
              //this.visible = false;
              //this.form.resetFields();
            });
        }
      });
    },
    handlePasswordChange(e) {
      e.preventDefault();
      this.passwordForm.validateFields((err, values) => {
        if (err) {
          console.log(err);
        } else {
          this.setloadingKeyAndDisableBtns("passwordLoading", true);
          apiClient
            .patch(
              "/parents/password/" + this.idParent + "/" + this.parentType,
              values
            )
            .then(async () => {
              this.$message.success(this.$t("success.parentMSA"));
              this.generatePdf(values, true);
            })
            .catch((e) => {
              this.$message.error(e.response.data.error.message);
            })
            .finally(() => {
              this.setloadingKeyAndDisableBtns("passwordLoading", false);
              //this.visible = false;
              //this.passwordForm.resetFields();
            });
        }
      });
    },
    generatePdf(values, withPwd = false) {
      generateLoginPdf({
        userName: values.userName || this.userName,
        password: values.password || "",
        withPwd,
        settings: this.settings,
        qrDataImage: this.qrDataImage,
        userType: "parent",
        t: this.$t.bind(this),
        locale: this.$i18n.locale,
      });
    },
    ...mapActions("settings", ["packHasBtnAccess"]),
    async sendSmsLoginToParent() {
      if (!(await this.packHasBtnAccess("sendSmsLogins"))) return;

      this.setloadingKeyAndDisableBtns("loadingSms", true);
      let father = this.info["father"];
      let mother = this.info["mother"];
      console.log(father, mother);
      let parent = {
        _id: this.idParent,
        father: {
          phone: father.phone,
          login: father.login?._id,
          userName: father.login?.userName,
        },
        mother: {
          phone: mother.phone,
          login: mother.login?._id,
          userName: mother.login?.userName,
        },
      };
      apiClient
        .put("/sms/loginparents", {
          target: ["father", "mother"],
          customNumbers: "",
          total: 4,
          tags: ["Logins parents"],
          parents: [parent],
        })
        .then((res) => {
          this.$message.success("SMS envoyé avec succeés");
        })
        .catch((e) => {
          console.log(e);
          switch (e.response.status) {
            case 401:
              this.$message.warning(e.response.data.message);

              break;

            default:
              this.$message.error(e.response.data.message);

              break;
          }
        })
        .finally(() => this.setloadingKeyAndDisableBtns("loadingSms", false));
    },
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
      this.passwordForm.validateFields();
    });
  },
  data() {
    return {
      parentType: "father",
      visible: false,
      hasErrors,
      qrDataImage: "",
      loadingSms: false,
      statusBtnLoading: false,
      userNameLoading: false,
      passwordLoading: false,
      qrCodeLoading: false,
      addParentCredentialsLoading: false,
      mfaDisabling: false,
      disableBtns: false,
      form: this.$form.createForm(this, { name: "parent_login" }),
      passwordForm: this.$form.createForm(this, { name: "parent_passwords" }),
    };
  },
};
</script>
<style>
.login-form .ant-col {
  width: 100% !important;
}

.fixed-height {
  height: 190px;
  /* Set your desired fixed height */
}

.app-logo {
  height: 38px;
  width: auto;
  margin-right: 10px;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  border-radius: 6px;
  padding: 2px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
</style>
